import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
import { EASE } from '../../lib/motion';

// Nombre qui se compte de 0 à `to` quand il entre dans l'écran (une seule fois).
// Le HTML initial porte déjà la valeur finale (pré-rendu, sans JavaScript, lecteurs d'écran) ;
// en mouvement réduit, aucun comptage.
export default function CountUp({ to, suffix = '', seconds = 1.4, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '0px 0px -40px 0px' });
  const reduce = useReducedMotion();
  const [value, setValue] = useState(to);

  useEffect(() => {
    if (!inView || reduce) return undefined;
    const controls = animate(0, to, {
      duration: seconds,
      ease: EASE,
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, reduce, to, seconds]);

  return (
    <span ref={ref} className={className}>
      {value}
      {suffix}
    </span>
  );
}
